import { FaroCoreApiTypes } from "@stellar/core-api-client";

/** Entity type to change access level */
export type AccessLevelEntityType = "project" | "snapshot";

/** Get the description for a given access level and entity type */
export function getAccessLevelDescription(
  type: AccessLevelEntityType,
  accessLevel: FaroCoreApiTypes.ProjectAccessLevel
): string {
  switch (accessLevel) {
    case "private":
      return `The ${type} can only be seen by members who are signed in and invited.`;
    case "unlisted":
      return `The ${type} can be seen by everyone with the link.`;
    default:
      return "";
  }
}

/** Interface for an access level item */
interface AccessLevelItem {
  /** Display label */
  label: string;

  /** Access level description */
  description: string;

  /** Access level value */
  value: FaroCoreApiTypes.ProjectAccessLevel;
}

/** Access level items array */
export function getAccessLevelItems(
  type: AccessLevelEntityType
): AccessLevelItem[] {
  switch (type) {
    case "project":
      return [
        {
          label: AccessLevelDisplayNames.private,
          description: getAccessLevelDescription("project", "private"),
          value: "private",
        },
        {
          label: AccessLevelDisplayNames.unlisted,
          description: getAccessLevelDescription("project", "unlisted"),
          value: "unlisted",
        },
      ];

    case "snapshot":
      return [
        {
          label: AccessLevelDisplayNames.private,
          description: getAccessLevelDescription("snapshot", "private"),
          value: "private",
        },
        {
          label: AccessLevelDisplayNames.unlisted,
          description: getAccessLevelDescription("snapshot", "unlisted"),
          value: "unlisted",
        },
      ];

    default:
      return [];
  }
}

/** Access level to display in readable text */
export const AccessLevelDisplayNames: {
  [key in FaroCoreApiTypes.ProjectAccessLevel]: string;
} = {
  ["private"]: "Private",
  ["unlisted"]: "Via link",
};

/** Type guard to check if a given string is a valid project access level */
export function isProjectAccessLevel(
  accessLevel: string
): accessLevel is FaroCoreApiTypes.ProjectAccessLevel {
  return accessLevel === "private" || accessLevel === "unlisted";
}
